import {
  defaultCellRenderer as renderer,
  defaultGroupRenderer as groupRenderer,
  columnAvatarConfig,
  EntityMainNameDefault,
  lineThroughRenderer,
  swivuGridSorterFn
} from "../utils/utils.jsx";
import { WIDGET_KEYS } from "./WidgetKeys.jsx";

export const INCENTIVE_POINT_COLUMNS = [
  {
    id: "task",
    text: "Entity",
    field: "taskName",
    type: WIDGET_KEYS.columnEntityMainName,
    flex: 1,
    groupRenderer,
    editor: false,
  },
  {
    id: "eligible-board-user",
    type: WIDGET_KEYS.swivuSortColumn,
    text: "Eligible Board User",
    field: "boardUserName",
    filterType: "_swivu_settings",
    tooltipRenderer: columnAvatarConfig.tooltipRenderer,
    renderer({ record, grid }) {
      if (!record.isGroupHeader) {
        const { boardUser } = record;
        return columnAvatarConfig.columnAvatarRenderer({
          image: boardUser.profileImageURL,
          name: boardUser.name,
          size: grid.rowHeight
        });
      }
    },
    flex: 1,
    groupRenderer,
    editor: false,
  },
  {
    id: "incentive",
    text: "Point Name",
    field: "incentiveName",
    type: WIDGET_KEYS.swivuSortColumn,
    flex: 1,
    renderer: ({ record }) => EntityMainNameDefault(lineThroughRenderer(record.incentiveName, record.incentive?.archived)),
    groupRenderer,
    editor: false,
  },
  {
    id: "incentive-type",
    text: "Type",
    field: "incentiveType",
    type: WIDGET_KEYS.swivuSortColumn,
    flex: 1,
    renderer,
    groupRenderer,
    editor: false,
  },
  {
    id: "points",
    text: "Points",
    field: "points",
    type: WIDGET_KEYS.swivuSortColumn,
    flex: 1,
    renderer,
    groupRenderer,
    editor: false,
    sortable: (a, b) => a.points - b.points,
  },
  {
    id: "status",
    type: WIDGET_KEYS.incentivePointsStatusColumn,
  },
  {
    id: "tag",
    text: "Tag",
    field: "pointTagRecord.name",
    type: WIDGET_KEYS.swivuSortColumn,
    flex: 1,
    groupRenderer,
    editor: false,
    sortable: (a, b) => {
      const recordA = a.pointTagRecord || {};
      const recordB = b.pointTagRecord || {};
      return swivuGridSorterFn.call({ field: "name" }, recordA, recordB)
    }
  },
  {
    id: "age",
    text: "Age",
    field: "aging",
    type: 'agingColumn',
    flex: 1,
    editor: false,
  }
];
